import { hubwayzHotelProfilePath } from "../../hubwayzHotelsTab/hubwayzHotelsTabConfig";

function finiteNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/**
 * Customer quote for the agent tools.
 *
 * customerSaleIls on the verified quote already includes HotelsRiver margin
 * and the Hubwayz sale commission (agentMarkupIls). This adds only the extra
 * calculator amount, once, on that sale price.
 * chargeIls is returned unchanged. Hubwayz supplier `price` is not read.
 */
export function hubwayzQuoteWithAddedCommission(quote, added) {
  const customerSaleIls = finiteNumber(quote?.customerSaleIls);
  const chargeIls = finiteNumber(quote?.chargeIls);
  const agentMarkupIls = finiteNumber(quote?.agentMarkupIls) ?? 0;
  if (customerSaleIls == null || customerSaleIls <= 0) {
    return {
      ok: false,
      reason: "missing_customer_sale",
      chargeIls,
      agentMarkupIls,
      customerSaleIls: null,
      addedCommissionIls: 0,
      customerQuoteIls: null,
    };
  }

  const type = added?.type === "%" ? "%" : "+";
  const value = finiteNumber(added?.value) ?? 0;
  let addedCommissionIls = 0;
  if (value > 0) {
    addedCommissionIls =
      type === "%"
        ? Math.ceil(customerSaleIls * (value / 100))
        : Math.round(value);
  }

  return {
    ok: true,
    reason: null,
    agentPriceAmount: finiteNumber(quote?.agentPriceAmount),
    agentPriceCurrency: quote?.agentPriceCurrency || null,
    chargeIls,
    agentNetIls: finiteNumber(quote?.agentNetIls),
    agentMarkupIls,
    customerSaleIls,
    addedCommissionIls,
    customerQuoteIls: Math.round(customerSaleIls + addedCommissionIls),
  };
}

/** Customer total for the order summary. chargeIls stays the verified charge. */
export function customerPriceWithAddedCommission(quote, addedIls) {
  const extra = finiteNumber(addedIls) ?? 0;
  if (!quote || extra <= 0) return quote;
  const sale = finiteNumber(quote.customerSaleIls ?? quote.customerPayIls);
  if (sale == null || sale <= 0) return quote;
  const next = Math.round(sale + extra);
  return {
    ...quote,
    customerSaleIls: next,
    customerPayIls: next,
    addedCommissionIls: extra,
  };
}

/** Absolute hotel-page URL. Empty id does not fall back to a supplier price URL. */
export function hubwayzHotelShareUrl(hotelId, { origin = "", search = "" } = {}) {
  const id = String(hotelId || "").trim();
  if (!id) return null;
  const path = hubwayzHotelProfilePath(id);
  if (!path || path.endsWith("/searchoffer")) return null;
  const base = String(origin || "").replace(/\/$/, "");
  const rawSearch = String(search || "");
  const query = !rawSearch ? "" : rawSearch.startsWith("?") ? rawSearch : `?${rawSearch}`;
  return `${base}${path}${query}`;
}
